import React from "react";

/**
 * Skeleton 로딩 플레이스홀더 컴포넌트
 *
 * variant별 기본 스타일:
 * - line: 텍스트 줄 형태 (h-4, rounded)
 * - rect: 직사각형 블록 형태 (h-20, rounded)
 * - circle: 원형 (h-10 w-10, rounded-full)
 * - card: 카드 형태 (h-32, rounded-2xl)
 *
 * count > 1이면 line variant를 여러 줄 렌더링
 */
function Skeleton({ variant = "line", width, height, className = "", count = 1 }) {
    // variant별 기본 스타일 정의
    const variantStyles = {
        line: "h-4 rounded",
        rect: "h-20 rounded",
        circle: "h-10 w-10 rounded-full",
        card: "h-32 rounded-2xl",
    };

    const baseStyle = variantStyles[variant] || variantStyles.line;

    // 인라인 스타일 (width/height prop으로 덮어쓰기 가능)
    const inlineStyle = {};
    if (width) inlineStyle.width = width;
    if (height) inlineStyle.height = height;

    // line variant + count > 1이면 여러 줄 렌더링
    if (variant === "line" && count > 1) {
        return (
            <div className="flex flex-col gap-2">
                {Array.from({ length: count }).map((_, index) => (
                    <div
                        key={index}
                        className={`animate-pulse bg-surface-hover ${baseStyle} ${className}`}
                        style={inlineStyle}
                    />
                ))}
            </div>
        );
    }

    return (
        <div
            className={`animate-pulse bg-surface-hover ${baseStyle} ${className}`}
            style={inlineStyle}
        />
    );
}

export default Skeleton;
